import t from 'tcomb';

export default function get_bundle(locale): t.Object {
  return window.require('web/io/' + locale.language);
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/get_bundle.js
 **/